module.exports = __webpack_public_path__ + "static/media/MK 4.9f020ce0.mp3";